export const getMixFromLocalStorage = ()  => JSON.parse(localStorage.getItem('mixes') || '[]');

export const addMixToLocalStorage = (mix: object) => {
    const allMixes = getMixFromLocalStorage();
    allMixes.push(mix);
    localStorage.setItem('mixes', JSON.stringify(allMixes))
};

export const removeMixToLocalStorage = (id: number) => {
    const allMixes = getMixFromLocalStorage();
    const filterMixes = allMixes.filter((item: any) => item.id !== id);
    localStorage.setItem('mixes', JSON.stringify(filterMixes));
};
